import { useCallback, useContext } from 'react';
import UserContext from '~/context/common/UserContext';
import { fetchFavorites } from '~/services/common';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useFavoritesFetcher(): (
  zip5: string,
  controller?: AbortController
) => Promise<void> {
  const {
    favorites: { setData, setError, setLoading }
  } = useContext(UserContext);

  return useCallback(
    async (zip5: string, controller?: AbortController) => {
      setLoading();
      fetchFavorites(zip5, controller)
        .then(res => {
          setData(res.data);
        })
        .catch(
          generateErrorLogger(
            'Get Favorites',
            {},
            { callback: setError, controller }
          )
        );
    },
    [setData, setError, setLoading]
  );
}
